// import ContentShimmer from "react-content-shimmer";
import { ShimmerPostItem } from 'react-shimmer-effects'

export const ProductCardShimmer = () => {
  return <ShimmerPostItem card title cta />
}
